/**
 * Fitzaa Shared Package
 * Cross-platform business logic and data models
 */

// ============================================================================
// CORE EXPORTS
// ============================================================================

export * from './types';

// ============================================================================
// SERVICES
// ============================================================================

export { FirebaseService } from './services/FirebaseService';
export { FirebaseFunctionsService } from './services/FirebaseFunctionsService';
export { ChallengeService } from './services/ChallengeService';
export { AuthService } from './services/AuthService';
export { AzureADAuthService } from './services/AzureADAuthService';
export { AzureADDirectService } from './services/AzureADDirectService';
export { LeaderboardService } from './services/LeaderboardService';
export { TeamsPhotoService } from './services/TeamsPhotoService';
export { TeamsPhotoFirebaseService } from './services/TeamsPhotoFirebaseService';
export { StorageServiceInterface, StorageConfig, UploadResult, BlobProperties } from './services/StorageServiceInterface';
export { HealthService, HealthServiceFactory } from './services/HealthService';
export { HealthIntegrationService } from './services/HealthIntegrationService';
export { HealthDataWatcher, WatcherConfig, WatcherStatus, HealthDataChange } from './services/HealthDataWatcher';
export { NotificationScheduler, NotificationSchedule, NotificationContent, NotificationStats } from './services/NotificationScheduler';
export { HealthIntegrationManager, HealthIntegrationConfig, IntegrationStatus } from './services/HealthIntegrationManager';

// ============================================================================
// UTILITIES
// ============================================================================

export * from './utils/calculationUtils';
export * from './utils/dateUtils';
export * from './utils/formatUtils';
export * from './utils/validationUtils';

// ============================================================================
// HOOKS
// ============================================================================

export { useNotification } from './hooks/useNotification';

// ============================================================================
// COMPONENTS
// ============================================================================

export { ChallengeTagProps, TagConfig, getTagConfig } from './components/ChallengeTag';
export {
    ChallengeProgressData,
    ChallengeData,
    CalendarDay,
    ChallengeProgressViewProps,
    getUnitDisplay,
    getMaxValue,
    getStepSize,
    formatValue,
    generateCalendarData,
    getCurrentMonthDisplay,
    calculateProgressStats,
    calculateTotalCompletedDays,
    calculateChallengeSuccessRate,
    calculateTotalPointsEarned,
    calculateDailyPointsEarned,
    calculatePartialPointsEarned,
    calculateChallengeTimeline,
    calculateDetailedProgressMetrics,
    formatProgressMetrics
} from './components/ChallengeProgressView';
export {
    EnhancedProgressMetricsProps,
    EnhancedProgressMetrics
} from './components/EnhancedProgressMetrics';
export {
    LeaderboardEntry,
    ChallengeLeaderboardProps,
    getRankIcon,
    formatProgress,
    formatValue as formatLeaderboardValue
} from './components/ChallengeLeaderboard';



// ============================================================================
// CONSTANTS & CONFIGURATION
// ============================================================================

export * from './config/azureADConfig';
export * from './config/loggingConfig';
export * from './config/environmentConfig';

// Asset keys (for use in app, not direct asset imports)
export const FITZAA_LOGO_FILENAME = 'fitzaaLogo.png'; 